var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kpiWrapper"},[_c('span',{staticClass:"font-1 value"},[_vm._v(" "+_vm._s(_vm.currencyData)+" "+_vm._s(_vm.decimalValue)+" ")]),_c('span',{staticClass:"font-5 text"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }